import React, { ComponentType, FunctionComponent } from 'react'
import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Link } from '@chakra-ui/react'
import { useSelector } from 'react-redux'
import { Link as ReactLink, Redirect, Route, RouteProps } from 'react-router-dom'

import { canAccessLegacyConstruction } from 'lib/admin-perms'
import { StoreState } from 'store'

type ConstructionRouteProps = Omit<RouteProps, 'component' | 'render' | 'children'> & {
  component: ComponentType<any>
}

export const ConstructionAccessDenied: FunctionComponent = () => (
  <Box maxW='container.md' mx='auto' p={8}>
    <Alert status='error' alignItems='flex-start'>
      <AlertIcon mt={1} />
      <Box>
        <AlertTitle>Construction tools are engineer-only</AlertTitle>
        <AlertDescription display='block' mt={1}>
          These legacy Hudson construction tools are restricted to engineers. You can continue
          working from{' '}
          <Link as={ReactLink} to='/homes' fontWeight='semibold' textDecoration='underline'>
            Homes
          </Link>
          .
        </AlertDescription>
      </Box>
    </Alert>
  </Box>
)

const ConstructionRoute: FunctionComponent<ConstructionRouteProps> = ({
  component: Component,
  ...routeProps
}) => {
  const admin = useSelector<StoreState, any>((state) => state.admin)
  const authenticated = Boolean(admin?.id)
  const canAccess = canAccessLegacyConstruction(admin)

  return (
    <Route
      {...routeProps}
      render={(props) => {
        if (!authenticated) {
          return (
            <Redirect
              to={{
                pathname: '/auth',
                state: { from: props.location }
              }}
            />
          )
        }

        if (!canAccess) {
          return <ConstructionAccessDenied />
        }

        return <Component {...props} />
      }}
    />
  )
}

export default ConstructionRoute
